{
  "de": {
    "bookmark": {
      "hints": {
        "body": "Entdecke jetzt kostenfreie Unterrichtsmaterialien in der fobizz Galerie und hol dir Inspiration für deinen Unterricht. Du kannst dir das Material merken, indem du auf das <i class='bi bi-heart'></i> klickst.",
        "title": "Deine Merkliste ist noch leer"
      },
      "links": {
        "toMaterial": "Unterrichtsmaterial entdecken"
      },
      "title": "Gemerktes Unterrichtsmaterial"
    }
  }
}
